import { message } from 'antd';

/** Shows a toast when Ant Design form validation fails (e.g. SEO fields below the fold). */
export const onFormFinishFailed = () => {
  message.error('Please fill in all required fields');
};

export default {
  onFormFinishFailed,
};
